export const urlsForType = {
    'cheatsheet': 'cheatsheets',
};